import { SettingsSection } from '@components'

import { FormItemsGroup, Space } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { DefaultInvoiceFooterNote } from './elements/DefaultInvoiceFooterNote'
import { DefaultInvoiceMessage } from './elements/DefaultInvoiceMessage'
import { DefaultTermsAndConditions } from './elements/DefaultTermsAndConditions'
import { ShowCustomerId } from './elements/ShowCustomerId'
import { ShowTermsAndConditions } from './elements/ShowTermsAndConditions'

export const ContentSettings = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <SettingsSection.Content title={t('settings.organization.external_invoice.content.title')}>
      <FormItemsGroup>
        <DefaultInvoiceMessage />
        <DefaultInvoiceFooterNote />
        <DefaultTermsAndConditions />
      </FormItemsGroup>
      <Space />
      <ShowTermsAndConditions />
      <ShowCustomerId />
    </SettingsSection.Content>
  )
}
